module.exports = __webpack_public_path__ + "94b6b8cf24350eb560b07def882c52a1.svg";